/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Container from "../../components/Container";
import NavigationHeader from "../../components/NavigationHeader";
import { ROUTES } from "../../constants/constants";
import ClientRegisterForm from "../../components/booking/ClientRegisterForm";
import { useNavigate } from "react-router-dom";

const ClientRegister = () => {
  const navigate = useNavigate();

  const onRegisterSubmit = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <Container>
      <NavigationHeader title="Register" back={ROUTES.HOME} />
      <ClientRegisterForm onSubmit={onRegisterSubmit} />
    </Container>
  );
};

export default ClientRegister;
